import { Injectable } from '@angular/core';
import { EventInput } from '@fullcalendar/angular';
import { EventoCalendarioAgenda } from 'src/app/admihair/api/dto/evento-calendario-agenda';
import { ConfiguracaoAgendaProfissional } from 'src/app/admihair/api/dto/configuracao-agenda-profissional';
import {
  AGENDA_STATUS_COLORS,
  AgendaStatus,
  BLOQUEIO_COLORS,
  EventColors
} from '../utils/agenda-utils';

@Injectable()
export class AgendaEventoMapperService {
  
  mapearParaEventoDoCalendario(
    eventoAgenda: EventoCalendarioAgenda,
    slotMinTime?: string | null,
    slotMaxTime?: string | null,
    idsProfissionais?: string[]
  ): EventInput {
    const cores = this.obterCoresDoEvento(eventoAgenda);
    const dataRegistro = this.normalizarDataRegistro(eventoAgenda.dataRegistro);
    const horaInicioPadrao = this.normalizarHoraSlot(slotMinTime, '08:00');
    const horaFimPadrao = this.normalizarHoraSlot(slotMaxTime, '17:00');

    const event: EventInput = {
      id: eventoAgenda.id,
      title: eventoAgenda.titulo,
      start: eventoAgenda.inicio ?? `${dataRegistro}T${horaInicioPadrao}`,
      end: eventoAgenda.fim ?? `${dataRegistro}T${horaFimPadrao}`,
      allDay: false,
      backgroundColor: cores.background,
      borderColor: cores.border,
      textColor: cores.text,
      editable: true,
      startEditable: true,
      durationEditable: true,
      extendedProps: {
        entityId: eventoAgenda.chave,
        entityType: eventoAgenda.tipo,
        dataRegistro: eventoAgenda.dataRegistro,
        status: eventoAgenda.status,
        descricao: eventoAgenda.descricao,
        nomeProfissional: eventoAgenda.nomeProfissional,
        profissionalId: eventoAgenda.profissionalId,
        itens: eventoAgenda.itens,
        tipo: eventoAgenda.tipo
      }
    };

    if (idsProfissionais?.length) {
      event.resourceIds = idsProfissionais;
    } else if (eventoAgenda.profissionalId) {
      event.resourceId = String(eventoAgenda.profissionalId);
    }

    return event;
  }

  mapearEventos(
    eventos: EventoCalendarioAgenda[],
    diaSemana: number,
    configuracoesProfissionais: ConfiguracaoAgendaProfissional[],
    slotMinTime?: string | null,
    slotMaxTime?: string | null
  ): EventInput[] {

    const bloqueioTotal = eventos.find(
      e => e.tipo === 'BLOQUEIO' && !e.profissionalId
    );

    if (bloqueioTotal) {
      const idsProfissionais = this.obterIdsProfissionaisDoDia(
        diaSemana,
        configuracoesProfissionais
      );
      return [
        this.mapearParaEventoDoCalendario(
          bloqueioTotal,
          slotMinTime,
          slotMaxTime,
          idsProfissionais
        )
      ];
    }

    return eventos.map(e =>
      this.mapearParaEventoDoCalendario(e, slotMinTime, slotMaxTime)
    );
  }

  private obterIdsProfissionaisDoDia(
    diaSemana: number,
    configuracoesProfissionais: ConfiguracaoAgendaProfissional[]
  ): string[] {
    return configuracoesProfissionais
      .filter(conf => conf.diaSemanaId === diaSemana && conf.profissional?.id)
      .map(conf => String(conf.profissional!.id!));
  }

  private obterCoresDoEvento(evento: EventoCalendarioAgenda): EventColors {
    if (evento.tipo === 'BLOQUEIO') {
      return BLOQUEIO_COLORS;
    }
    const status = evento.status;
    return this.isAgendaStatus(status)
      ? AGENDA_STATUS_COLORS[status]
      : AGENDA_STATUS_COLORS.AGENDADO;
  }

  private isAgendaStatus(value: any): value is AgendaStatus {
    return value in AGENDA_STATUS_COLORS;
  }

  private normalizarHoraSlot(
    slot: string | null | undefined,
    fallback: string
  ): string {
    if (!slot) {
      return fallback;
    }
    return slot.substring(0, 5);
  }

  private normalizarDataRegistro(dataRegistro: Date | string): string {
    if (typeof dataRegistro === 'string') {
      return dataRegistro.substring(0, 10);
    }
    return dataRegistro.toISOString().substring(0, 10);
  }
}
